import {createApp} from 'vue';
import CentreSelectComponent from "./V3/Components/CentreSelectComponent.vue";
import UserSearchComponent from "./V3/Components/UserSearchComponent.vue";

export function ModalVueSetup() {

    if (document.getElementById('vue-app-modal').length < 1 ) {
        return;
    }

    const vueAppModal = createApp({});
    vueAppModal.component('centre-select-component', CentreSelectComponent);
    vueAppModal.component('user-search-component-modal', UserSearchComponent);
    vueAppModal.mount('#vue-app-modal');
};
